import React from 'react';
import '../../styles/social.css';

function SocialIcons({ size = '1.2rem', hoverScale = 1.1, isTransparent }) {
  const icons = [
    { normal: '/Social_FB_Normal.svg', active: '/Social_FB_Active.svg', alt: 'Facebook' },
    { normal: '/Social_Insta_Normal.svg', active: '/Social_Insta_Active.svg', alt: 'Instagram' },
    { normal: '/Social_TLG_Normal.svg', active: '/Social_TLG_Active.svg', alt: 'Telegram' },
    { normal: '/Social_VK_Normal.svg', active: '/Social_VK_Active.svg', alt: 'VK' },
    { normal: '/Social_YT_Normal.svg', active: '/Social_YT_Active.svg', alt: 'YouTube' },
  ];

  return (
    <div className={`social-icons ${isTransparent ? 'transparent' : ''}`} style={{ gap: `calc(${size} / 2)` }}>
      {icons.map((icon, index) => (
        <img
          key={index}
          src={icon.normal}
          alt={icon.alt}
          className={`social-icon ${isTransparent ? 'icon-black' : ''}`}
          style={{
            width: size,
            height: size,
            transition: `transform 0.2s ease-in-out, filter 0.2s ease-in-out`,
            filter: isTransparent ? 'invert(1)' : 'none', // Применение инверсии
          }}
          onMouseEnter={(e) => {
            e.target.style.filter = 'none'; // Убираем инверсию цвета
            e.target.src = icon.active; // Меняем картинку на активную
            e.target.style.transform = `scale(${hoverScale})`; // Масштабируем
          }}
          onMouseLeave={(e) => {
            e.target.style.filter = isTransparent ? 'invert(1)' : 'none'; // Возвращаем инверсию цвета, если меню прозрачное
            e.target.src = icon.normal; // Возвращаем нормальную картинку
            e.target.style.transform = 'scale(1)'; // Возвращаем масштаб
          }}
        />
      ))}
    </div>
  );
}

export default SocialIcons;
